var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lds-spinner"},_vm._l((8),function(i){return _c('div',{key:i,style:({ 'background-color': _vm.$vuetify.theme.dark ? '#fff' : '#13274E' })})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }